import { FcGoogle } from "react-icons/fc";
import { BsGithub } from "react-icons/bs";

import styles from "./style.module.scss";
import classNames from "classnames";

type LoginButtonTypes = {
  type: "google" | "github";
  text: string;
  children: any;
};

const LoginButton = (props: any) => {
  const { type, text, children }: LoginButtonTypes = props;

  const isGoogle = type === "google";

  const loginBtnClassnames = classNames(styles.loginButton, {
    [styles.googleBg]: isGoogle,
  });

  const loginBtnTextClassnames = classNames(styles.loginButtonText, {
    [styles.blueText]: isGoogle,
  });

  const handleIcon = isGoogle ? (
    <FcGoogle size="1.5em" />
  ) : (
    <BsGithub size="1.5em" />
  );

  return (
    <div className={styles.loginButtonWrapper}>
      <button className={loginBtnClassnames}>
        <div className={styles.loginButtonIcon}>{handleIcon}</div>
        <span className={loginBtnTextClassnames}>{text}</span>
      </button>
      {children}
    </div>
  );
};

export default LoginButton;
